export default {
  pt: {
    'tickets.ticketKanban.priority.low': 'Baixa',
    'tickets.ticketKanban.priority.normal': 'Normal',
    'tickets.ticketKanban.priority.high': 'Alta',
    'tickets.ticketKanban.priority.urgent': 'Urgente',
    'tickets.ticketKanban.contractSuffix': 'Contrato {{contract}} · ',
    'tickets.ticketKanban.oneLoad': '{{count}} carga',
    'tickets.ticketKanban.manyLoads': '{{count}} cargas',
    'tickets.ticketKanban.action.submitted': 'Enviar',
    'tickets.ticketKanban.action.approved': 'Aprovar',
    'tickets.ticketKanban.status.draft': 'Rascunho',
    'tickets.ticketKanban.status.submitted': 'Enviada',
    'tickets.ticketKanban.status.under_review': 'Em análise',
    'tickets.ticketKanban.status.approved': 'Aprovada',
    'tickets.ticketKanban.status.in_progress': 'Em execução',
    'tickets.ticketKanban.status.completed': 'Concluída',
    'tickets.ticketKanban.status.cancelled': 'Cancelada',
  },
  en: {
    'tickets.ticketKanban.priority.low': 'Low',
    'tickets.ticketKanban.priority.normal': 'Normal',
    'tickets.ticketKanban.priority.high': 'High',
    'tickets.ticketKanban.priority.urgent': 'Urgent',
    'tickets.ticketKanban.contractSuffix': 'Contract {{contract}} · ',
    'tickets.ticketKanban.oneLoad': '{{count}} load',
    'tickets.ticketKanban.manyLoads': '{{count}} loads',
    'tickets.ticketKanban.action.submitted': 'Submit',
    'tickets.ticketKanban.action.approved': 'Approve',
    'tickets.ticketKanban.status.draft': 'Draft',
    'tickets.ticketKanban.status.submitted': 'Submitted',
    'tickets.ticketKanban.status.under_review': 'Under review',
    'tickets.ticketKanban.status.approved': 'Approved',
    'tickets.ticketKanban.status.in_progress': 'In progress',
    'tickets.ticketKanban.status.completed': 'Completed',
    'tickets.ticketKanban.status.cancelled': 'Cancelled',
  },
  es: {
    'tickets.ticketKanban.priority.low': 'Baja',
    'tickets.ticketKanban.priority.normal': 'Normal',
    'tickets.ticketKanban.priority.high': 'Alta',
    'tickets.ticketKanban.priority.urgent': 'Urgente',
    'tickets.ticketKanban.contractSuffix': 'Contrato {{contract}} · ',
    'tickets.ticketKanban.oneLoad': '{{count}} carga',
    'tickets.ticketKanban.manyLoads': '{{count}} cargas',
    'tickets.ticketKanban.action.submitted': 'Enviar',
    'tickets.ticketKanban.action.approved': 'Aprobar',
    'tickets.ticketKanban.status.draft': 'Borrador',
    'tickets.ticketKanban.status.submitted': 'Enviada',
    'tickets.ticketKanban.status.under_review': 'En análisis',
    'tickets.ticketKanban.status.approved': 'Aprobada',
    'tickets.ticketKanban.status.in_progress': 'En ejecución',
    'tickets.ticketKanban.status.completed': 'Completada',
    'tickets.ticketKanban.status.cancelled': 'Cancelada',
  },
}
